// src/translations/index.js
import nav from './nav.js';
import hero from './hero.js';
import about from './about.js';
import contact from './contact.js';
import footer from './footer.js';

export default {
  nav,
  hero,
  about,
  contact,
  footer
};